import { Dialog, DialogContent } from '@material-ui/core'
import {
  Centered,
  CenteredButton,
  ContainerWarning,
  Description,
  IconImage,
  Title
} from '../../dashboard-jetty.styled'
import { Button } from '../../../../../components'
import { Images } from '../../../../../assets'

const WarningModal = ({ isOpen, toggleModal }) => {
  return (
    <Dialog open={isOpen} onClose={toggleModal} fullWidth maxWidth='xs'>
      <ContainerWarning>
        <Centered>
          <IconImage src={Images.WarningModalIcon} />
        </Centered>
        <Title>Jetty Capacity Exceeded</Title>
        <DialogContent>
          <Description>More than 2 Cranes/Barges</Description>
        </DialogContent>
        <CenteredButton>
          <Button onClick={toggleModal}>Back</Button>
        </CenteredButton>
      </ContainerWarning>
    </Dialog>
  )
}

export default WarningModal
